export enum StarChefVisitStatus {
    PENDING = 'PENDING',
    COOK_ALLOCATED = 'COOK_ALLOCATED',
    CANCELLED = 'CANCELLED',
    FULFILLED = 'FULFILLED',
    RESCHEDULED = 'RESCHEDULED',
}